import { AppContextType } from 'marketplace-ui-common/types';
import { ReviewType } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc';
import { useGetSummaryQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';

interface useAIReviewSummaryProps {
  appContext: AppContextType;
  entityId: number;
  language: string;
  reviewType: ReviewType;
  skip?: boolean;
}

export function useAIReviewSummary({
  entityId,
  language,
  reviewType,
  skip,
}: useAIReviewSummaryProps) {
  const { data, loading, error } = useGetSummaryQuery({
    variables: { entityId, language, type: reviewType },
    skip,
  });

  const reviewSummary = loading || error ? null : data?.summary;
  const reviewSummaryLastUpdated = loading || error ? null : data?.updatedAt;

  return { reviewSummary, reviewSummaryLastUpdated };
}
